import React from 'react';
import usePwa from '../../hooks/usePwa';
import Button from './Button';
import './InstallBanner.css';

const InstallBanner = () => {
  const { installApp } = usePwa();

  return (
    <section className="install-banner" role="dialog" aria-live="polite">
      <div className="install-banner__content">
        <div className="install-banner__text">
          <p className="install-banner__title">Install Inventory Management</p>
          <p className="install-banner__subtitle">Add the app to your home screen for faster access.</p>
        </div>
      </div>
      <div className="install-banner__actions">
        <Button
          variant="primary"
          size="small"
          onClick={installApp}
          className="install-banner__action install-banner__action--primary"
        >
          Install
        </Button>
      </div>
    </section>
  );
};

export default InstallBanner;


